import React, { Component } from 'react';
import { PnkConnect } from '../../../pnk-react/pnk-miniredux';
import $ from 'jquery';
import AppUtils from '../../../apputils';
//import { AddOrganizerData, UpdateOrganizerDetails } from '../../../models/organizers';
import TourForm from './createTour';
import { CreateTours, UpdateTourDetails } from '../../../models/tour';

//import DateTimePicker from 'react-datetime-picker';

class addTour extends Component {
    constructor() {
        super()
        this.state = {
            showButtonType: "Add Tour",
            txtTourName: '',
            txtTourDuration: '',
            ddlTourTheme: '',
            txtTourCities: '',
            txtTourHighlights: '',
            ddlTourStatus: '',
            txtTourCost: '',
            fileTourDetailsPdf: '',
            fileTourImage: '',
            ddlTourFlight: '',
            currentTourId: '',
            tour_image: [],

            actionType: 'save',
            showEditBtn: 'none',
            editData: false,
            sendData: false,
            mode: 'add'
        }
        this.editDataObj = {}
        this.data = {}
    }

    HandleTourInput = (e) => {

        if (document.getElementById('fileTourDetailsPdf').value !== undefined && document.getElementById('fileTourDetailsPdf').value !== '') {
            this.editDataObj['fileTourDetailsPdf'] = document.getElementById('fileTourDetailsPdf').value;
            this.setState({
                fileTourDetailsPdf: document.getElementById('fileTourDetailsPdf').value
            })
        }

        if (document.getElementById('fileTourImage').value !== undefined && document.getElementById('fileTourImage').value !== '') {
            this.editDataObj['fileTourImage'] = document.getElementById('fileTourImage').value;
            this.setState({
                fileTourImage: document.getElementById('fileTourImage').value
            })
        }


      

        let val = e.target.value;
        let name = e.target.name;
       
        this.editDataObj[name] = val;
        this.setState({ [name]: val });
    }

    HideModal = () => {
        this.props.componentprops.currentAction.close();
    }

    HandleTourImage = (e) => {
        this.editDataObj[e.target.name] = e.target.value;
        this.state.fileTourImage[e.target.name] = e.target.value;
        // let arr = []
        // arr.push(e.target.value);
        alert(JSON.stringify(this.state.fileTourImage))
        this.setState({
            fileTourImage: this.state.fileTourImage.push(e.target.value)
        })
    }
    componentDidMount = () => {
        this.ChangePageMode()
    }
    AddSpecialChar = (str) => {
        if (str !== '' && str !== undefined && str !== null)
            return str.replace(/pnk_Amp/g, "&");
    }
    ChangePageMode = () => {
        let obj;
        //  alert(this.props.componentprops.currentAction.data)
        // console.log(JSON.stringify(this.props.componentprops.currentAction.data))
        if (this.props.componentprops.currentAction !== undefined && this.props.componentprops.currentAction.action === 'Detail') {

            this.setState({
                showEditBtn: 'block',
                mode: 'edit',
                renderChild: true,
                currentTourId: this.props.componentprops.currentAction.data[0]._id
            })

            let tour_data = this.props.componentprops.currentAction.data[0]

            let img = this.props.componentprops.currentAction.data[0].tour_image.split(',')

            this.setState({
                tour_image: img
            })

            console.log(this.state.tour_image)

            //    alert(tour_data.tour_image);
            this.editDataObj = {
                txtTourName: this.AddSpecialChar(tour_data.tour_name),
                txtTourDuration: this.AddSpecialChar(tour_data.tour_duration),
                ddlTourTheme: this.AddSpecialChar(tour_data.tour_theme),
                txtTourCities: this.AddSpecialChar(tour_data.tour_cities),
                ddlTourStatus: this.props.componentprops.currentAction.data[0].tour_status,
                txtTourHighlights: this.AddSpecialChar(tour_data.tour_highlights),
                ddlTourFlight: this.props.componentprops.currentAction.data[0].tour_flight,
                txtTourCost: this.AddSpecialChar(tour_data.tour_pricing),
                fileTourImage: this.props.componentprops.currentAction.data[0].tour_image,
                fileTourDetailsPdf: this.props.componentprops.currentAction.data[0].tour_details
            }

            this.setState({
                ddlTourTheme: this.AddSpecialChar(tour_data.tour_theme),
            })

            obj = {

                organizerActionHeading: 'Organizer Detail',
                editDeleteDiv: true,
                getOrganizerData: true,
                currentTourId: this.props.componentprops.currentAction.data[0]._id,
                showButtonType: 'Update Tour',
                formModeActivity: true,
                btnOrganizerOuterDiv: false,


            };
            console.log(this.editDataObj.organizer_name);
            let form = document.getElementById("frmTourEntry");
            let elements = form.elements;

            for (let i = 0, len = elements.length; i < len; ++i) {
                if (elements[i].id !== '')
                    elements[i].disabled = true;
            }

        }
        else {
            obj = { formModeActivity: false, btnOrganizerOuterDiv: true, editDeleteDiv: false };
            let form = document.getElementById("frmTourEntry");
            let elements = form.elements;
            for (let i = 0, len = elements.length; i < len; ++i) {
                elements[i].disabled = false;
            }
        }

        this.setState(obj);
    }

    ShowEditMode = () => {

        let form = document.getElementById("frmTourEntry");
        let elements = form.elements;
        for (let i = 0, len = elements.length; i < len; ++i) {
            // if (elements[i].id !== "txtOrganizerEmail" && elements[i].id !== "txtOrganizerMobile" ) {

            elements[i].disabled = false;
            //   // elements[2].disabled = false;
            // }
            // if (elements[i].id !== "txtOrganizerMobile") {
            //     elements[i].disabled = false;
            // }
        }

        this.setState({ formModeActivity: false, organizerActionHeading: 'Edit User', btnUserProfileOuterDiv: true, showEditBtn: 'none', actionType: 'update' })

    }

    RemoveSpecialChar = (str) => {
        if (str !== '' && str !== undefined && str !== null)
            return str.replace(/&/g, "pnk_Amp");

    }

    SaveTourEntryData = (e) => {
        //   alert('iiii' + JSON.stringify(e))
        //   alert(this.state.txtOrganizerName)
        this.data = {
            txtTourName: this.RemoveSpecialChar(e.txtTourName),
            txtTourDuration: this.RemoveSpecialChar(e.txtTourDuration),
            ddlTourTheme: e.ddlTourTheme,
            txtTourCities: this.RemoveSpecialChar(e.txtTourCities),
            fileTourImage: e.fileTourImage,
            fileTourDetailsPdf: e.fileTourDetailsPdf,
            ddlTourStatus: e.ddlTourStatus,
            txtTourCost: this.RemoveSpecialChar(e.txtTourCost),
            ddlTourFlight: e.ddlTourFlight,
            txtTourHighlights: this.RemoveSpecialChar(e.txtTourHighlights)
        }

        if (this.state.actionType === 'save') {
            this.setState({
                sendData: true
            })
        }
        else {
            this.setState({
                editData: true, sendData: false
            })
        }

        console.log(this.data);
        console.log(this.editDataObj);
    }


    HandleUpdateTourDataSuccessResponse = (res) => {
        //  alert('jjjj')
        console.log(JSON.stringify(res));

        if (res !== false) {
            // this.props.componentprops.currentAction.organizerListUpdate = true
            this.setState({
                editData: false,
            })
            this.HideModal();
            // this.props.componentprops.handleClose();

        }
        else {
            this.setState({
                editData: false
            })
        }
    }

    HandleAddTourDataSuccessResponse = (res) => {

        console.log(JSON.stringify(res));
        if (res !== false) {

            document.getElementById('spnSuccessMessageTitle').innerText = "Server Response - ";
            // document.getElementById('spnSuccessMessage').innerText = res.data.addorganizerresponse.message.value;
            document.getElementById('spnSuccessMessage').innerText = 'success';
            let that = this;
            $('#crmSuccessAlert').slideDown().slideUp(3000, function () {
                that.HideModal();
            })

        }
        else {
            document.getElementById('spnWarningMessageTitle').innerText = "Server Response - ";
            document.getElementById('spnWarningMessage').innerText = this.props.PnkStore.GetData('error').prettyMessage;

            let that = this;
            $('#crmWarningAlert').slideDown().slideUp(3000, function () {
                that.HideModal();
            })

        }
        this.setState({ sendData: false });
    }



    HandleRouting = (route) => {
        AppUtils.HandlePageClick(this.props.componentprops, route)
    }


    render() {
        return (
            <div>
                <TourForm {...this.props} HandleRouting={this.HandleRouting}
                    HandleTourInput={this.HandleTourInput} editDataObj={this.editDataObj}
                    mystate={this.state} HandleTourImage={this.HandleTourImage}
                    SaveTourEntryData={this.SaveTourEntryData}
                    ShowEditMode={this.ShowEditMode}

                />
                {(this.state.sendData === true) ? CreateTours(this.props.PnkStore, this.data, this.HandleAddTourDataSuccessResponse) : ""}
                {(this.state.editData === true) ? UpdateTourDetails(this.props.PnkStore, this.state.currentTourId, this.data, this.HandleUpdateTourDataSuccessResponse) : ""}
            </div>
        )
    }
}

export const CreateTour = PnkConnect(addTour, '');
